import { SelectIF } from '@/types/common';

export type FavoriteEntityT = 'Clothing' | 'Outfit';

export const FAVORITE_ENTITIES: SelectIF<FavoriteEntityT>[] = [
    {
        value: 'Clothing',
        label: 'Одежда',
    },
    {
        value: 'Outfit',
        label: 'Образ',
    },
];
